import { useState, useEffect, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { mainSiteUrl } from '@/mocks/categories';

export default function ArtigoFooter() {
  const location = useLocation();

  const handleCategoriesClick = (e: React.MouseEvent) => {
    e.preventDefault();
    if (location.pathname !== '/') {
      window.location.href = '/#categorias';
    } else {
      document.getElementById('categorias')?.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-foreground-900 rounded-t-[2.5rem] mx-3 md:mx-5 overflow-hidden">
      <div className="relative z-10 px-8 md:px-12 py-12">
        <div className="max-w-4xl mx-auto text-center">
          <Link to="/" className="font-heading text-xl font-bold text-background-50 whitespace-nowrap">
            CSSBuy<span className="text-primary-400">Spreadsheet</span>
          </Link>
          <div className="mt-6 flex flex-wrap items-center justify-center gap-4">
            <Link to="/" className="text-sm text-foreground-400 hover:text-background-50 transition-colors duration-200 font-medium">
              Início
            </Link>
            <a
              href="/#categorias"
              onClick={handleCategoriesClick}
              className="text-sm text-foreground-400 hover:text-background-50 transition-colors duration-200 cursor-pointer"
            >
              Categorias
            </a>
            <Link to="/artigo-cssbuyspreadsheet-guia-completo-2026" className="text-sm text-foreground-400 hover:text-background-50 transition-colors duration-200">
              Guia Completo
            </Link>
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="text-sm text-foreground-400 hover:text-background-50 transition-colors duration-200"
            >
              CSSBuy Sheet
            </a>
          </div>
          <div className="mt-8 pt-6 border-t border-foreground-800/40">
            <p className="text-xs text-foreground-500">
              &copy; 2026 CSSBuySpreadsheet.watch — Todos os direitos reservados.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}